// extracted by mini-css-extract-plugin
module.exports = {"root":"Settings_root__pyfMy","search":"Settings_search__1jMXn","filter":"Settings_filter__3ve1p"};